'use strict';

// Estado compartido entre instancias de la directiva para evitar que el toast de
// "return" se repita al abrir/cerrar el config varias veces seguidas.
var returnToastTimer = null;

var formulaCtrl = ['$scope', 'BuilderDataService', 'toast', function($scope, BuilderDataService, toast) {
    var _this = this;

    let objectFormula = {
        formula: null,
        variables: [],
        totalLabel: null
    };

    if (_this.element?.templateData?.isAdvanced) {
        _this.element.templateData.formula = JSON.parse(JSON.stringify(objectFormula));
    } else { // clean advanced
        _this.element.templateData.formulaAdvanced = JSON.parse(JSON.stringify(objectFormula));
    }

    if (_this.element?.templateData && !_this.element.templateData.returnDataType) {
        _this.element.templateData.returnDataType = 'number';
    }

    this.showReturnToast = () => {
        if (returnToastTimer) return;
        returnToastTimer = true;
        toast.error('Debe definir qué retorna la función ("return").');
        returnToastTimer = setTimeout(() => {
            returnToastTimer = null;
        }, 3000);
    }; 

    var allowedCharacters = [
        'a',
        'b',
        'c',
        'd',
        'e',
        'f',
        'g',
        'h',
        'i',
        'j',
        'k',
        'l',
        'm',
        'n',
        'o',
        'p',
        'q',
        'r',
        's',
        't',
        'u',
        'v',
        'w',
        'x',
        'y',
        'z',
        '+',
        '-',
        '/',
        '*',
        '%',
        '(',
        ')',
        '.',
        ',',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '0',
        '=',
        '>',
        '!',
        '<',
        '?',
        ':',
        '&',
        '|',"'"
    ];

    var cleanFormula = function(formula) {
        formula = formula.trim();
        formula = formula.replace(' ', '');

        for (var i = 0; i < formula.length; i++) {
            if (allowedCharacters.indexOf(formula[i]) < 0) {
                formula = formula.replace(formula[i], '');
            }
            if (formula[i] === ',') {
                formula = formula.replace(formula[i], '.');
            }
        }
        return formula;
    };

    var getVariables = function(formulaData) {
        var variables = [];
        var allowedVaraibles = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

        //we parse the formula string and push variables to variables array.
        for (var i = 0; i < formulaData.formula.length; i++) {
            if (allowedVaraibles.indexOf(formulaData.formula[i]) > -1 && variables.indexOf(formulaData.formula[i]) < 0) {
                variables.push(formulaData.formula[i]);
            }
        }

        var newVariables = variables.filter(function(v) {
            //if variable is present we remove it
            for (var i = 0; i < formulaData.variables.length; i++) {
                if (v === formulaData.variables[i].variable) {
                    return false;
                }
            }
            return true;
        });

        formulaData.variables = formulaData.variables.filter(function(variable) {
            return variables.indexOf(variable.variable) > -1;
        });

        //we add remaining variables
        newVariables.forEach(function(variable) {
            formulaData.variables.push({
                variable: variable,
                dataSource: null
            });
        });
        return formulaData;
    };

    this.updateFormula = function() {
        this.element.templateData.formula.formula = cleanFormula(this.element.templateData.formula.formula);
        this.element.templateData.formula = getVariables(this.element.templateData.formula);
    };

    this.updateFormulaAdvanced = () => {
        this.element.templateData.formulaAdvanced = this.getVariablesAdvanced(this.element.templateData.formulaAdvanced);
        this.calculateFormulaAdvanced();
    }

    this.getVariablesAdvanced = (formulaData) => {
        if (!Array.isArray(formulaData?.variables)) {
            formulaData.variables = [];
        }    
        const variables = new Set();
        let formula = formulaData?.formula;
    
        if (formula) {
            formula = formula.replace(/(["'])(?:(?=(\\?))\2.)*?\1/g, '');
            const regex = /\b[a-zA-Z]\b/g;
    
            let match;
            while ((match = regex.exec(formula)) !== null) {
                console.log('match', match)
                const variable = match[0];
                variables.add(variable);
            }
    
            if (!Array.isArray(formulaData.variables)) {
                formulaData.variables = [];
            }
    
            if (variables.size === 0) {
                formulaData.variables = [];
            } else {
                formulaData.variables = formulaData.variables.filter(v => variables.has(v.variable));
                variables.forEach((variable) => {
                    const exists = formulaData.variables.some(v => v.variable === variable);
                    if (!exists) {
                        formulaData.variables.push({
                            variable: variable,
                            dataSource: null
                        });
                    }
                });
            }
        }
        return formulaData;
    };

    this.getNumberElements = function() {
        let els=BuilderDataService.getElementsFormula('number',this.element);
        let els1=BuilderDataService.getElementsFormula('select',this.element,true);        
        let els2=BuilderDataService.getElementsFormula('multiple',this.element,true);        
        let els3=BuilderDataService.getElementsFormula('formula',this.element);
        let els4=BuilderDataService.getElementsFormula('autonumeric',this.element);
        return els.concat(els1,els2,els3, els4);
    };

    this.isNumberField = function(variable) {
        return variable.dataSource && variable.dataSource.type === 'number';
    };
    
    this.validateInput = function(variable) {
        if (this.isNumberField(variable)) {
            // Regex to allow only numbers and limit to 14 characters
            variable.testValue = variable.testValue?.replace(/\s+/g, '').replace(/[^0-9]/g, '').slice(0, 14);
        }
    };

    this.getSimpleListElements = function() {
        let parent = BuilderDataService.getParentSimpleList(this.element);
        if (!parent) {
            let els = BuilderDataService.getElements('simplelist', this.element, false);        
            return (els);
        } else {
            return [];
        }
    };

    this.changeReturnDataType = function() {
        if (this.element.templateData.returnDataType === 'text') {
            this.element.templateData.maxDecimalsCount = null;
            this.element.templateData.forceDecimals = false;
            this.element.templateData.thousandSeparator = false;
        }
    };

    this.changeScope = function(){
        if(this.element.templateData.fxScope  && this.element.templateData.fxScope!="" &&  (!this.element.templateData.fxScopeResume || this.element.templateData.fxScopeResume=="")){
            this.element.templateData.fxScopeResume="SUM";
        }
    }

    var returnTestValue = function(formulaData, letter) {
        return formulaData.variables.filter(function(v) {
            return v.variable === letter;
        })[0].testValue || 0;
    };

    this.executeFormula = function(formulaData, variables,decimals) {
        _this.element.templateData.maxDecimalsCount = _this.element.templateData.formula.decimals
        var compiledFormula = formulaData.formula;
        for (var i = 0; i < variables.length; i++) {
            var value = returnTestValue(formulaData, variables[i].variable);
            var regex = new RegExp(variables[i].variable, 'g');
            compiledFormula = compiledFormula.replace(regex, "(".concat(value,")"));
        }

        try {
            var result = eval(compiledFormula);
            if(decimals && !isNaN(decimals))
                result=result.toFixed(decimals)
            return result;
        } catch (e) {
            return 'error';
        }
    };

    this.executeFormulaAdvanced = function(formulaData, variables) {
        return new Promise((resolve, reject) => {
            if (!formulaData.formula) {
                reject('No formula provided');
                return;
            }
    
            let compiledFormula = formulaData.formula;    
            let variableNames = [];
            let variableValues = [];
    
            // Function to convert all values to strings if any variable is not numeric
            const convertValuesNumber = () => {
                return new Promise((resolve) => {
                    for (let i = 0; i < variables.length; i++) {
                        let value;
                        if (variables[i].dataSource?.type !== 'number') {
                            value = `"${variables[i].testValue || ''}"`;
                        } else {
                            value = variables[i].testValue || 0;
                        }
                        variableNames.push(variables[i].variable);
                        variableValues.push(value);
                    }
                    resolve();
                });
            };
    
            // Function to replace the variables in the formula with the corresponding values
            const replaceVariables = () => {
                return new Promise((resolve) => {
                    for (let i = 0; i < variableNames.length; i++) {
                        let regex = new RegExp('\\b' + variableNames[i] + '\\b', 'g');
                        compiledFormula = compiledFormula.replace(regex, variableValues[i]);
                    }
                    resolve();
                });
            };
    
            // Execute the functions sequentially
            convertValuesNumber()
                .then(replaceVariables)
                .then(() => {
                    try {
                        if (!compiledFormula.includes("return ")) {
                            compiledFormula = `return (${compiledFormula})`;
                            _this.showReturnToast();
                        }
                        let result = eval(`(function (){${compiledFormula}})()`);
                                                
                        resolve(result);
                    } catch (e) {
                        console.error('Error evaluating formula:', e);
                        resolve('error');
                    }
                });
        });
    };

    this.calculateFormulaAdvanced = function() {
        const formulaData = this.element?.templateData?.formulaAdvanced;
        const variables = this.element?.templateData?.formulaAdvanced?.variables;
    
        if (formulaData && variables) {
            this.executeFormulaAdvanced(formulaData, variables)
                .then(result => {
                    this.calculatedValue = result;
                    $scope.$apply(); // Ensure that Angular updates the view
                })
                .catch(() => {
                    this.calculatedValue = 'error';
                    $scope.$apply(); // Ensure that Angular updates the view
                });
        }
    };

    $scope.$watch(
        () => _this.element?.templateData?.formulaAdvanced?.variables,
        (newVal, oldVal) => {
            if (_this.element?.templateData?.formulaAdvanced.variables && newVal !== oldVal) {
                _this.calculateFormulaAdvanced();
            }
        },
        true
    );

    $scope.$watch(
        () => _this.element?.templateData?.formulaAdvanced?.formula,
        (newVal, oldVal) => {
            if (_this.element?.templateData?.formulaAdvanced?.formula && _this.element?.templateData?.formulaAdvanced?.formula !== '' && newVal !== oldVal) {
                _this.updateFormulaAdvanced();
            }
        }
    );

    $scope.$watch(
        () => _this.element?.templateData?.isAdvanced,
        (newVal, oldVal) => {
            if (newVal !== oldVal) {
                if (newVal) {
                    _this.element.templateData.formula = JSON.parse(JSON.stringify(objectFormula));
                    _this.calculatedValue = '';
                } else {
                    _this.element.templateData.formulaAdvanced = JSON.parse(JSON.stringify(objectFormula));
                    _this.calculatedValue = '';
                }
            }
        }
    )

    this.getFlattenedInputElements = function (form, isForValidator = false) {
        const processPages = function(pages, formType) {
            let flattenedElements = [];
    
            pages.forEach((page, pageIndex) => {
                const elementsWithLevels = _this.getElementsWithLevels(page.fields, pageIndex, 1, formType);
                flattenedElements = flattenedElements.concat(elementsWithLevels);
            });
            return flattenedElements;
        };
        let flattenedPages = [];
        let flattenedValidatePages = [];
        flattenedPages = processPages(form.pages, "Formulario");
        if (isForValidator) {
            flattenedValidatePages = processPages(form.validate_pages, "Validador");
        } 
        return flattenedPages.concat(flattenedValidatePages)
    };
    this.getElementsWithLevels = function (fields, pageIndex, level, formType) {
        return fields.flatMap(function (field) {
            const isElementInSimpleList = function(nodes) {
                return nodes.some(node => {
                    if (node.id === _this.element.id) {
                        return true;
                    }
                    if (node.nodes && node.nodes.length > 0) {
                        return isElementInSimpleList(node.nodes);
                    }
                    return false;
                });
            };

            if (field.type === 'simplelist') {
                const elementInCurrentSimpleList = field.id === _this.element.id || isElementInSimpleList(field.nodes || []);

                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: `Página ${pageIndex + 1}`
                };
                const nodesProcessed = elementInCurrentSimpleList
                    ? _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType)
                    : [];

                return [currentField].concat(nodesProcessed);
            }

            if (field.type === 'group') {
                const currentField = {
                    ...field,
                    level: level,
                    disabled: false,
                    form: formType,
                    page: `Página ${pageIndex + 1}`
                };
                // Procesar los nodos dentro de 'group' despues de 'group'
                const nodesProcessed = _this.getElementsWithLevels(field.nodes, pageIndex, level + 1, formType);
                return [currentField].concat(nodesProcessed);
            }
            return [{ ...field, level: level, disabled: false, form: formType, page: `Página ${pageIndex + 1}` }];
        });
    };
    
    this.form = BuilderDataService.getForm();
    this.inputElementsForForm = this.getFlattenedInputElements(this.form, this.isForValidator);
    
    // Call calculateFormulaAdvanced to initialize the calculated value
    this.calculateFormulaAdvanced();
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            element: '=',
            form: '=',
            isForValidator:'='
        },
        controller: formulaCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-builder/formulaDirective.html'
    };
};
